import { IMasterListItemAction } from '../entity-master/components/master-list-item/master-list-item.interface';
import { TrackedTime } from '../tracked-time-data/models/tracked-time.model';
import { TrackedTimeDataDispatcher } from '../tracked-time-data/tracked-time-data.dispatcher';
import { TrackedTimeActionsEnum } from './components/tracked-time-master.data';

export class TrackedTimeQuickActionList {
  constructor(public trackedTimeDataDispatcher: TrackedTimeDataDispatcher) {}

  onQuickAction(action: IMasterListItemAction, trackedTime: TrackedTime) {
    if (action.id === TrackedTimeActionsEnum.bill_time) {
      this.trackedTimeDataDispatcher.billTrackedTime(
        trackedTime.id,
        trackedTime.clientReference.id
      );
    }
  }
}
